<template>
<div class="gift-card-promo">
  <div v-if="successMessage == false">
    <div class="row">
      <div class="col-md-12">
        <div class="gift-card-promo">
          <div v-if="successMessage == false">
            <div class="row">
              <div class="col-md-12 mt-3 mb-3">
             
              </div>
            </div>
          </div>
          <p v-if="successMessage" v-html="successMessage"></p>

          <p v-if="errorMessage" class='error-message'>{{errorMessage}}</p>
          <div v-if="promoOpen" class="active-promo">
          <form role="form" action="insert.php" method="post" v-on:submit.prevent="submitForm" v-if="successMessage == false">
            <div class="row">
              <div class="col-md-6">
                <h2>Your Details</h2>
                <div class="form-group">
                  <label for="name">Your Full Name</label>
                  <input type="text" autocomplete='given-name' class="form-control" id="name" name="name" v-model="name" required>
                </div>
                <div class="form-group">
                  <label for="phone">Phone</label>
                  <input type="text" class="form-control" id="phone" name="phone" v-model="phoneNumber" required>
                </div>
                <div class="form-group">
                  <label for="email">Email</label>
                  <input type="email" autocomplete='email' class="form-control" id="email" name="email" v-model="emailAddress" required>
                </div>
              </div>
              <div class="col-md-6">
                <h2>Installation address</h2>
                <div class="form-group">
                  <label for="streetAddress">Street Address</label>
                  <input type="text" autocomplete='street-address' class="form-control" id="streetAddress" name="streetAddress" v-model="streetAddress" required>
                </div>
                <div class="form-group ">
                  <label for="suburb">Suburb</label>
                  <input type="text" autocomplete='' class="form-control" id="suburb" name="suburb" v-model="suburb" required />
                </div>
                <div class="row">
                  <div class="form-group col-md-6">
                    <label for="state">State</label>
                    <select name="state" v-model="state" required class="form-control">
    <option disabled value="0">State</option>
    <option v-for="(state, key) in states" :value="state" v-bind:key="key" >{{state}}</option>
  </select>
                  </div>
                  <div class="form-group col-md-6">
                    <label for="postcode">Postcode</label>
                    <input type="text" autocomplete='' class="form-control" id="postcode" name="postcode" v-model="postcode" required />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
            <h2>Product Details</h2>
            <div class="form-group" v-for="(product, key) in productDetails" v-bind:key="key">
                  <label for="tankModel">Tank Model</label>
                  <select name="size" v-model="product.model" required class="form-control">
                      <option disabled value="0">Model</option>
                      <option v-for="(system, key) in availableSystems" :value="system" v-bind:key="key">{{system}}</option>
                    </select>
                    <div class="form-group date-of-purchase">
                      <label for="dateOfPurchase">Date of installation</label>
                      <datepicker v-model="product.dateOfPurchase" required input-class="form-control" :disabledDates="disabledDates"></datepicker><i class="fa fa-calendar-alt"> </i>
                    </div>
            </div>
          </div>
            <div class="col-md-6">
            <div class="form-group">
              <h2>Upload Receipts</h2>
              <label for="fileUploadInput">Accepted formats are JPG, PNG, GIF and PDF</label>
              <br/>
              <div class="btn btn-primary file-select" v-on:click="openNativeFile()">Select files</div>
              <input type="file" ref="file" class="form-control-file" id="fileUploadInput" name="fileUploadInput" required v-on:change="uploadFiles">
              <div v-if="fileErrorMessage" class="error-message">{{fileErrorMessage}}</div>
              <div class="uploaded-filelist" v-if="files.length > 0">
                <ul class="fa-ul">
                  <li v-for="(file, key) in files" v-bind:key="key"><i class="fa fa-times-circle" v-on:click="removeFile(key)"> </i> {{uploadedFileName(file)}}</li>
                </ul>
              </div>
            </div>

          </div>
        </div>
            <div class="form-group">
              <div class="form-group">
                <label for="installer-agree">
                  <input type="checkbox" name="installer-agree" value="check" id="installer-agree" v-model="installerAgreed" required/> I confirm this installation was completed by Australian Hot Water and I have attached a copy of the invoice.
                </label>
                <label for="agree">
          <input type="checkbox" name="checkbox" value="check" id="agree" v-model="termsAgreed" required/> I have read and agree to the <a href="#terms" data-toggle="modal" data-target="#exampleModal">Terms and Conditions</a>
          </label>
              </div>

              <input type="submit" id="submit" name="submit" class="btn btn-primary pull-right" value="Submit" :disabled="formDisabled" />
            </div>
          </form>
        </div>
        </div>
      </div>
    </div>
  </div>
  <p v-if="successMessage" v-html="successMessage"></p>
  <p v-if="errorMessage" class='error-message'>{{errorMessage}}</p>
  <TermsModal/>
</div>
</template>
<script>
var axios = require('axios');
import Datepicker from 'vuejs-datepicker';
import availableSystems from './availableSystems.js';
import TermsModal from './TermsModal';
export default {
  name: 'gift-card-promo',
  components: {
    Datepicker,
    TermsModal
  },
  data() {
    return {
      minEntries: 1,
      promoOpen: true,
      disabledDates: {
        to: new Date(2021, 10, 1),
        from: new Date(2021, 10, 31) // Disable all dates after specific date
      },
      name: '',
      company: '',
      streetAddress: '',
      suburb: '',
      state: '',
      postcode: '',
      phoneNumber: '',
      emailAddress: '',
      productDetails: [{
        model: '',
        dateOfPurchase: '',
        value: 0,
        modelid: 0
      }],
      states: [

        'ACT',
        'NT',
        'NSW',
        'QLD',
        'SA',
        'TAS',
        'VIC',
        'WA',
      ],
      availableSystems: availableSystems,
      termsAgreed: false,
      installerAgreed: false,
      formDisabled: false,
      fileErrorMessage: '',
      files: [],
      successMessage: false,
      errorMessage: false
    };
  },
  mounted() {},
  methods: {
    openNativeFile() {
      var fileControl = document.querySelector('#fileUploadInput');
      fileControl.click();
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    isPurchaseValid(product) {
      if (product.model && product.serial) {
        return true;
      }
    },
    uploadFiles() {
      console.log('Uploading images');
      var self = this;
      self.formDisabled = true;
      self.fileErrorMessage = false;
      var allFiles = this.$refs.file.files;
      for (var i = 0; i < allFiles.length; i++) {
        var formData = new FormData();
        formData.append('file', allFiles[i]);
        axios.post('server/uploadfile.php',
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(function(response) {
            console.log('Uploaded image successfully');
            self.files = [];
            self.files.push(response.data.data.imgSrc);
            self.formDisabled = false;
          })
          .catch(function() {
            self.formDisabled = false;
            self.fileErrorMessage = 'Problem uploading image. Allowed filetypes are jpeg, pdf, png and gif. Max size 2mb';
            console.log('Failed uploading image');
          });
      }
    },
    submitForm() {
      var self = this;
      self.errorMessage = false;

        axios.post('server/insert.php', {
          name: self.name,
          streetAddress: self.streetAddress,
          suburb: self.suburb,
          state: self.state,
          postcode: self.postcode,
          phone: self.phoneNumber,
          email: self.emailAddress,
          relatedImages: self.files.join(','),
          productDetails: self.productDetails
        }).then(function() {
          self.successMessage =
            `<div class="col-md-9 container text-center">Thank you for your claim, it has been successfully sent through for processing. Once your claim has been approved, it will be emailed to the email address that was sent in the claim form. If you have any queries, email <a href="mailto:marketing@dux.com.au">marketing@dux.com.au</a></div>`;
        }).catch(function() {
          self.errorMessage = 'Something went wrong. Please ensure all fields are entered';
        });
    },
    uploadedFileName(file) {
      var splitFile = file.split(/_(.+)/);
      if (splitFile.length > 1) {
        return file.split(/_(.+)/)[1];
      } else {
        return splitFile[0];
      }
    }
  },
  computed: {
    totalClaim: function() {
      var totalClaim = 0;
      for (var i = 0; i < this.productDetails.length; i++) {
        totalClaim += parseInt(this.productDetails[i].value);
      }
      return totalClaim;
    }

  }
};
</script>
<style>
.gift-card-promo {
  padding: 15px;
}
#fileUploadInput {
  opacity: 0;
}
</style>
